import { Helmet } from 'react-helmet-async'

const SITE_SUFFIX = ' - SitRepp.io'

function ensureSuffix(title: string): string {
  if (!title.trim()) return `SitRepp.io`
  return title.endsWith('SitRepp.io') || title.endsWith(SITE_SUFFIX) ? title : `${title}${SITE_SUFFIX}`
}

export interface PageMetaProps {
  /** Page title; " - SitRepp.io" is appended if not already present. */
  title: string
  /** Meta description for SEO and social previews. */
  description: string
  /** Optional canonical or share URL for og:url. */
  ogUrl?: string
  /** Optional image URL for og:image / twitter:image. */
  ogImage?: string
}

/**
 * Sets document title, meta description, and optional Open Graph / Twitter Card tags.
 * Use on each page so shared links and browser tabs show the right title and description.
 */
export function PageMeta({ title, description, ogUrl, ogImage }: PageMetaProps) {
  const fullTitle = ensureSuffix(title)

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {ogUrl != null && (
        <>
          <meta property="og:type" content="website" />
          <meta property="og:url" content={ogUrl} />
          <meta property="og:title" content={fullTitle} />
          <meta property="og:description" content={description} />
          {ogImage != null && <meta property="og:image" content={ogImage} />}
          <meta name="twitter:card" content={ogImage ? 'summary_large_image' : 'summary'} />
          <meta name="twitter:title" content={fullTitle} />
          <meta name="twitter:description" content={description} />
          {ogImage != null && <meta name="twitter:image" content={ogImage} />}
        </>
      )}
    </Helmet>
  )
}
